import Nullstack from 'nullstack';
export default function IconArrowsMaximize({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-maximize",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "16 4 20 4 20 8"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "10",
    x2: "20",
    y2: "4"
  }), "   ", Nullstack.element("polyline", {
    points: "8 20 4 20 4 16"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "20",
    x2: "10",
    y2: "14"
  }), "   ", Nullstack.element("polyline", {
    points: "16 20 20 20 20 16"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "14",
    x2: "20",
    y2: "20"
  }), "   ", Nullstack.element("polyline", {
    points: "8 4 4 4 4 8"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "4",
    x2: "10",
    y2: "10"
  }), " ");
}